import utilities from '@mooveguru/js-utilities';
export const noContent = 'N/A';

export function formatNumber(value) {
	if (!value) {
		return noContent;
	}

	const numberValue = Number(value);

	if (isNaN(numberValue)) {
		return noContent;
	}

	return utilities.number.convertNumberToFormattedString(numberValue, 'en-US');
}
